import { all } from 'redux-saga/effects';

import coreSaga from './core/saga';
import uiSaga from './ui/saga';
import authSaga from './auth/saga';
import cartSaga from './cart/saga';
import ordersSaga from './orders/saga';
import peeriusSaga from './peerius/saga';
import checkoutSaga from './checkout/saga';
import userSaga from './user/saga';
import searchSaga from './search/saga';
import wishlistSaga from './wishlist/saga';
import wishlistsSaga from './wishlists/saga';
import storeLocatorSaga from './store-locator/saga';
import notifymeSaga from './notifyme/saga';
import storeDetailsSaga from './store-details/saga';
import globalSaga from './global/saga';
import paymentSaga from './payment/saga';
import orderSaga from './order/saga';
import productSaga from './product/saga';
import reviewsSaga from './reviews/saga';
import addressSaga from './address/saga';
import myAccount from './my-account/saga';
import minipdpSaga from './minipdp/saga';
import analyticsSaga from './analytics/saga';
import powerReviewsSaga from './power-reviews/saga';
import navigationSaga from './navigation/saga';
import modifaceSaga from './modiface/saga';

export default function* rootSaga() {
    yield all([
        ...coreSaga,
        ...uiSaga,
        ...authSaga,
        ...myAccount,
        ...cartSaga,
        ...ordersSaga,
        peeriusSaga,
        ...searchSaga,
        ...checkoutSaga,
        ...userSaga,
        ...wishlistSaga,
        ...wishlistsSaga,
        ...notifymeSaga,
        ...storeLocatorSaga,
        ...storeDetailsSaga,
        ...globalSaga,
        ...paymentSaga,
        ...orderSaga,
        ...productSaga,
        ...reviewsSaga,
        ...addressSaga,
        ...analyticsSaga,
        ...minipdpSaga,
        ...powerReviewsSaga,
        ...navigationSaga,
        ...modifaceSaga,
    ]);
}
